<template>
  <div id="app">
    <router-view  v-if="show"/>
  </div>
</template>

<script>
export default {
  name: "App",
  data () {
    return {
      show:false
    }
  },
  created() {
    this.$store.dispatch("GetInfo").then(()=>{
      this.show=true
    });
  },
};

</script>

<style lang="scss">
html body {
  padding: 0;
  margin: 0;
}
#app {
  font-family: Microsoft YaHei ,-apple-system,BlinkMacSystemFont,"Segoe UI",Roboto,"Helvetica Neue",Arial,sans-serif,"Apple Color Emoji","Segoe UI Emoji","Segoe UI Symbol";
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #16181a;
  width: 100%;
  font-weight: normal;
  > div {
    width: 100%;
  }
}

@font-face {
  font-family: YouSheBiaoTiHei;
  src: url("./assets/myFirstFont.ttf"); /* IE9 */
}

body {
  min-width: 1280px;
  overflow-x: hidden;
}
</style>
